import InfoIcon from 'components/icons/InfoIcon';
import CheckboxField from 'components/forms/checkboxField/CheckboxField';
import { useTranslation } from 'react-i18next';
import {
  AutoTranslationContainer,
  ManageLanguagesModalDescription,
} from '../ManageLanguagesModal.styles';

const ManageLanguagesAutoTranslationField = () => {
  const { t } = useTranslation();

  return (
    <AutoTranslationContainer>
      <ManageLanguagesModalDescription>
        {t('pageAutomations.common.manageLanguagesModal.autoTranslation')}
        <InfoIcon
          id="auto-translation-description-icon"
          tooltipText={t(
            'pageAutomations.common.manageLanguagesModal.autoTranslationTooltip',
          )}
        />
      </ManageLanguagesModalDescription>
      <CheckboxField name="autoTranslate">
        {t('pageAutomations.common.manageLanguagesModal.autoTranslationLabel')}
      </CheckboxField>
    </AutoTranslationContainer>
  );
};

export default ManageLanguagesAutoTranslationField;
